export type CompanyOwnershipIdentity = { website: string | null; legalName: string | null; licence: string | null; address: string | null };
export const COMPANY_OWNERSHIP_SETTINGS: CompanyOwnershipIdentity = {
  website: "tashiraev.com",
  legalName: "TASHIRA E-Visa & Tourism L.L.C-FZ",
  licence: "2541485.01",
  address: "Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, UAE",
};

function required(value: string | null, field: string) {
  const normalized = value?.trim();
  if (!normalized) throw new Error(`Company ${field} is not configured`);
  return normalized;
}

export function companyFooterStatement(identity: CompanyOwnershipIdentity, language: "ar" | "en") {
  const domain = companyDomain(identity.website);
  const legalName = required(identity.legalName, "legalName");
  const licence = companyLicenceNumber(identity.licence);
  const address = required(identity.address, "address");
  return language === "ar"
    ? `${domain} موقع مملوك ومُدار من ${legalName} (رخصة تجارية ${licence})، شركة خاصة تقدّم المساعدة في تقديم طلبات تأشيرة الإمارات كطرف ثالث. لسنا موقعًا حكوميًا ولا دائرة هجرة ولا سفارة ولا قنصلية، ولسنا تابعين لأي جهة حكومية. الموافقة ومدد المعالجة والدخول إلى الإمارات قرارات تعود للجهات المختصة وحدها ولا يمكن ضمانها. المقر: ${address}.`
    : `${domain} is owned and operated by ${legalName} (Commercial Licence ${licence}), a private company providing UAE visa application assistance as a third-party service. We are not a government website, an immigration authority, an embassy or a consulate, and we are not affiliated with any government agency. Approval, processing times and entry into the UAE are decided solely by the competent UAE authorities and cannot be guaranteed. Registered at ${address}.`;
}

export function companyDomain(website: string | null) {
  const value = required(website, "website");
  try { return new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`).hostname.replace(/^www\./i, "").toLowerCase(); }
  catch { throw new Error("Company website is invalid"); }
}

export function companyLicenceNumber(licence: string | null) {
  const value = required(licence, "licence");
  return value.match(/\d[\d.]+/)?.[0] ?? value;
}

export function companyOwnershipStatement(identity: CompanyOwnershipIdentity, language: "ar" | "en") {
  const domain = companyDomain(identity.website);
  const legalName = required(identity.legalName, "legalName");
  const licence = companyLicenceNumber(identity.licence);
  return language === "ar"
    ? `${domain} موقع مملوك ومُدار من ${legalName} — رخصة تجارية رقم ${licence}، ميدان فري زون، دبي.`
    : `${domain} is owned and operated by ${legalName} — commercial licence ${licence}, Meydan Free Zone, Dubai.`;
}
